import { WarningHandsSvg } from '../modals/modal-plans/svg'

export type VariantName = 'NO_REPORTS_WARNING'

export const VARIANTS_PLANS: {
  [key in VariantName]: {
    title: string
    ilustration: () => any
    mainActionLabel?: string
    secondaryActionLabel: string
    showButtonCancel?: boolean
    amplitudeKind?: string
    name: VariantName
  }
} = {
  NO_REPORTS_WARNING: {
    title: 'Ya no tienes reportes disponibles',
    ilustration: WarningHandsSvg,
    amplitudeKind: 'no_reports_warning',
    secondaryActionLabel: 'Cerrar',
    showButtonCancel: true,
    name: 'NO_REPORTS_WARNING'
  }
}
